import { useQuery } from 'react-query';
import { GetSignupResponse } from '@monovo/ev-anytime';
import { fetchFn } from '../../AnytimeEligibilityV2/services/chargeAnytimeAPI';

export const useSignupQuery = (
  enabled: boolean,
  accountId: string | null | undefined,
  customerId: string | null | undefined,
) => {
  // TODO: add response type
  return useQuery<GetSignupResponse, unknown>({
    queryKey: `charge-anytime-signup-${accountId}`,
    enabled: enabled && !!accountId && !!customerId,
    retryOnMount: false,
    queryFn: () => {
      return fetchFn(
        `/v1/signup/customers/${customerId}/accounts/${accountId}`,
        {
          method: 'get',
        },
      );
    },
  });
};
